import script from "./X1CalendarDrop.vue?vue&type=script&lang=ts&setup=true"
export * from "./X1CalendarDrop.vue?vue&type=script&lang=ts&setup=true"

import "./X1CalendarDrop.vue?vue&type=style&index=0&id=762a02d0&lang=css&scoped=true"

import exportComponent from "D:\\x1\\vue3-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-762a02d0"]])

export default __exports__